'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Actions = exports.Actions = {
  ASSIGN: 'ASSIGN',
  CREATE_TICKET: 'CREATE_TICKET',
  NONE: 'NONE'
};

var AssignmentGroups = exports.AssignmentGroups = {
  TEAMS_AND_TEAM_MEMBERS: 'TEAMS_AND_TEAM_MEMBERS',
  OWNERS: 'OWNERS',
  UNASSIGNED: 'UNASSIGNED',
  INBOX: 'INBOX'
};

var AssignmentTypes = exports.AssignmentTypes = {
  ROUND_ROBIN: 'ROUND_ROBIN',
  UNASSIGNED: 'UNASSIGNED'
};

var FallbackAssignmentGroups = exports.FallbackAssignmentGroups = {
  TEAMS_AND_TEAM_MEMBERS: 'TEAMS_AND_TEAM_MEMBERS',
  UNASSIGNED: 'UNASSIGNED'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/RuleTypes.js
// module id = 454
// module chunks = 2 3